module.exports = __webpack_public_path__ + "img/loading_gif.56ccaec7.gif";